/* @generated from adl module kachemedia.specsheet.ooh */

import * as ADL from './../../runtime/adl';
import * as common_db from './../../common/db';
import * as kachemedia_specsheet_db from './db';
import * as kachemedia_specsheet_qms from './qms';
import * as sys_types from './../../sys/types';

/**
 * Data on OOH campaigns, bookings and panels, based on the CSV file
 */
export interface OohCampaignBooking {
  frameName: string;
  sizeType: string;
  campaignNumber: string;
  campaignName: string;
  startDate: string;
  endDate: string;
  advertiser: string;
  agency: string;
  bookingType: string;
  product: string;
  extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef;
}

export function makeOohCampaignBooking(
  input: {
    frameName: string,
    sizeType: string,
    campaignNumber: string,
    campaignName: string,
    startDate: string,
    endDate: string,
    advertiser: string,
    agency: string,
    bookingType: string,
    product: string,
    extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef,
  }
): OohCampaignBooking {
  return {
    frameName: input.frameName,
    sizeType: input.sizeType,
    campaignNumber: input.campaignNumber,
    campaignName: input.campaignName,
    startDate: input.startDate,
    endDate: input.endDate,
    advertiser: input.advertiser,
    agency: input.agency,
    bookingType: input.bookingType,
    product: input.product,
    extCampaignRef: input.extCampaignRef,
  };
}

const OohCampaignBooking_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Data on OOH campaigns, bookings and panels, based on the CSV file\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"frameName","default":{"kind":"nothing"},"name":"frameName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"sizeType","default":{"kind":"nothing"},"name":"sizeType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"campaignNumber","default":{"kind":"nothing"},"name":"campaignNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"campaignName","default":{"kind":"nothing"},"name":"campaignName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"advertiser","default":{"kind":"nothing"},"name":"advertiser","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"agency","default":{"kind":"nothing"},"name":"agency","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bookingType","default":{"kind":"nothing"},"name":"bookingType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"extCampaignRef","default":{"kind":"nothing"},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}}]}},"name":"OohCampaignBooking","version":{"kind":"nothing"}}};

export const snOohCampaignBooking: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"OohCampaignBooking"};

export function texprOohCampaignBooking(): ADL.ATypeExpr<OohCampaignBooking> {
  return {value : {typeRef : {kind: "reference", value : snOohCampaignBooking}, parameters : []}};
}

/**
 * Data on OOH placements, based on the CSV file
 */
export interface OohPlacement {
  frameName: string;
  locationName: string;
  suburb: string;
  state: string;
  physicalWidth: string;
  physicalHeight: string;
  finishHeight: string;
  finishWidth: string;
  pixelHeight: string;
  pixelWidth: string;
  spotDuration: string;
  placementType: string;
  sizeType: string;
  mediaType0: string;
  mediaType1: string;
  /**
   * Mapping to TSS Placement table
   */
  tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>;
}

export function makeOohPlacement(
  input: {
    frameName: string,
    locationName: string,
    suburb: string,
    state: string,
    physicalWidth: string,
    physicalHeight: string,
    finishHeight: string,
    finishWidth: string,
    pixelHeight: string,
    pixelWidth: string,
    spotDuration: string,
    placementType: string,
    sizeType: string,
    mediaType0: string,
    mediaType1: string,
    tssPlacementId: common_db.DbKey<kachemedia_specsheet_db.Placement>,
  }
): OohPlacement {
  return {
    frameName: input.frameName,
    locationName: input.locationName,
    suburb: input.suburb,
    state: input.state,
    physicalWidth: input.physicalWidth,
    physicalHeight: input.physicalHeight,
    finishHeight: input.finishHeight,
    finishWidth: input.finishWidth,
    pixelHeight: input.pixelHeight,
    pixelWidth: input.pixelWidth,
    spotDuration: input.spotDuration,
    placementType: input.placementType,
    sizeType: input.sizeType,
    mediaType0: input.mediaType0,
    mediaType1: input.mediaType1,
    tssPlacementId: input.tssPlacementId,
  };
}

const OohPlacement_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["frameName","sizeType"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Data on OOH placements, based on the CSV file\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"frameName","default":{"kind":"nothing"},"name":"frameName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"locationName","default":{"kind":"nothing"},"name":"locationName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"suburb","default":{"kind":"nothing"},"name":"suburb","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"nothing"},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"physicalWidth","default":{"kind":"nothing"},"name":"physicalWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"physicalHeight","default":{"kind":"nothing"},"name":"physicalHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"finishHeight","default":{"kind":"nothing"},"name":"finishHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"finishWidth","default":{"kind":"nothing"},"name":"finishWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"pixelHeight","default":{"kind":"nothing"},"name":"pixelHeight","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"pixelWidth","default":{"kind":"nothing"},"name":"pixelWidth","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"spotDuration","default":{"kind":"nothing"},"name":"spotDuration","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"placementType","default":{"kind":"nothing"},"name":"placementType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"sizeType","default":{"kind":"nothing"},"name":"sizeType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"mediaType0","default":{"kind":"nothing"},"name":"mediaType0","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"mediaType1","default":{"kind":"nothing"},"name":"mediaType1","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Mapping to TSS Placement table\n"}],"serializedName":"tssPlacementId","default":{"kind":"nothing"},"name":"tssPlacementId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}}]}},"name":"OohPlacement","version":{"kind":"nothing"}}};

export const snOohPlacement: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"OohPlacement"};

export function texprOohPlacement(): ADL.ATypeExpr<OohPlacement> {
  return {value : {typeRef : {kind: "reference", value : snOohPlacement}, parameters : []}};
}

/**
 * Stores the relationship between an OOH campaign and a TSS campaign.
 */
export interface OohCampaign {
  tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
  oohCampaignCode: string;
  oohClient: string;
  extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef;
}

export function makeOohCampaign(
  input: {
    tssCampaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
    oohCampaignCode: string,
    oohClient: string,
    extCampaignRef: kachemedia_specsheet_db.ExtCampaignRef,
  }
): OohCampaign {
  return {
    tssCampaignId: input.tssCampaignId,
    oohCampaignCode: input.oohCampaignCode,
    oohClient: input.oohClient,
    extCampaignRef: input.extCampaignRef,
  };
}

const OohCampaign_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["oohCampaignCode"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Stores the relationship between an OOH campaign and a TSS campaign.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"tssCampaignId","default":{"kind":"nothing"},"name":"tssCampaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"oohCampaignCode","default":{"kind":"nothing"},"name":"oohCampaignCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"oohClient","default":{"kind":"nothing"},"name":"oohClient","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"extCampaignRef","default":{"kind":"nothing"},"name":"extCampaignRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"ExtCampaignRef"}},"parameters":[]}}]}},"name":"OohCampaign","version":{"kind":"nothing"}}};

export const snOohCampaign: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"OohCampaign"};

export function texprOohCampaign(): ADL.ATypeExpr<OohCampaign> {
  return {value : {typeRef : {kind: "reference", value : snOohCampaign}, parameters : []}};
}

export interface BookingDates {
  startDate: string;
  endDate: string;
}

export function makeBookingDates(
  input: {
    startDate: string,
    endDate: string,
  }
): BookingDates {
  return {
    startDate: input.startDate,
    endDate: input.endDate,
  };
}

const BookingDates_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"startDate","default":{"kind":"nothing"},"name":"startDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"BookingDates","version":{"kind":"nothing"}}};

export const snBookingDates: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"BookingDates"};

export function texprBookingDates(): ADL.ATypeExpr<BookingDates> {
  return {value : {typeRef : {kind: "reference", value : snBookingDates}, parameters : []}};
}

export interface OohTablesMap {
  oohCampaigns: sys_types.Map<common_db.DbKey<OohCampaign>, OohCampaign>;
  oohBookings: sys_types.Map<common_db.DbKey<kachemedia_specsheet_qms.QmsBooking>, kachemedia_specsheet_qms.QmsBooking>;
}

export function makeOohTablesMap(
  input: {
    oohCampaigns: sys_types.Map<common_db.DbKey<OohCampaign>, OohCampaign>,
    oohBookings: sys_types.Map<common_db.DbKey<kachemedia_specsheet_qms.QmsBooking>, kachemedia_specsheet_qms.QmsBooking>,
  }
): OohTablesMap {
  return {
    oohCampaigns: input.oohCampaigns,
    oohBookings: input.oohBookings,
  };
}

const OohTablesMap_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"oohCampaigns","default":{"kind":"nothing"},"name":"oohCampaigns","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.ooh","name":"OohCampaign"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.ooh","name":"OohCampaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"oohBookings","default":{"kind":"nothing"},"name":"oohBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsBooking"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.qms","name":"QmsBooking"}},"parameters":[]}]}}]}},"name":"OohTablesMap","version":{"kind":"nothing"}}};

export const snOohTablesMap: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"OohTablesMap"};

export function texprOohTablesMap(): ADL.ATypeExpr<OohTablesMap> {
  return {value : {typeRef : {kind: "reference", value : snOohTablesMap}, parameters : []}};
}

/**
 * SizeType attributes
 */
export interface SizeTypeSpec {
  sizeType: string;
  pdfFileName: string;
  videoMaxFileSize: string;
  staticMaxFileSize: string;
  videoAspectRatio: string;
  staticAspectRatio: string;
  videoCodec: string;
  videoFrameRate: string;
  videoBitRate: string;
  staticResolution: string;
  staticColour: string;
  format: string;
  videoSupportAudioCodec: string;
  videoSupportAudioBitRate: string;
  videoSupportSampleRate: string;
  channels: string;
  videoAudioLevels: string;
  maxTruePeak: string;
  stock: string;
  bleedLeft: string;
  bleedTop: string;
  bleedRight: string;
  bleedBottom: string;
  printColour: string;
  printFormat: string;
  printResolution: string;
  additionalInformation: string;
  trimSize: string;
}

export function makeSizeTypeSpec(
  input: {
    sizeType: string,
    pdfFileName: string,
    videoMaxFileSize: string,
    staticMaxFileSize: string,
    videoAspectRatio: string,
    staticAspectRatio: string,
    videoCodec: string,
    videoFrameRate: string,
    videoBitRate: string,
    staticResolution: string,
    staticColour: string,
    format: string,
    videoSupportAudioCodec: string,
    videoSupportAudioBitRate: string,
    videoSupportSampleRate: string,
    channels: string,
    videoAudioLevels: string,
    maxTruePeak: string,
    stock: string,
    bleedLeft: string,
    bleedTop: string,
    bleedRight: string,
    bleedBottom: string,
    printColour: string,
    printFormat: string,
    printResolution: string,
    additionalInformation: string,
    trimSize: string,
  }
): SizeTypeSpec {
  return {
    sizeType: input.sizeType,
    pdfFileName: input.pdfFileName,
    videoMaxFileSize: input.videoMaxFileSize,
    staticMaxFileSize: input.staticMaxFileSize,
    videoAspectRatio: input.videoAspectRatio,
    staticAspectRatio: input.staticAspectRatio,
    videoCodec: input.videoCodec,
    videoFrameRate: input.videoFrameRate,
    videoBitRate: input.videoBitRate,
    staticResolution: input.staticResolution,
    staticColour: input.staticColour,
    format: input.format,
    videoSupportAudioCodec: input.videoSupportAudioCodec,
    videoSupportAudioBitRate: input.videoSupportAudioBitRate,
    videoSupportSampleRate: input.videoSupportSampleRate,
    channels: input.channels,
    videoAudioLevels: input.videoAudioLevels,
    maxTruePeak: input.maxTruePeak,
    stock: input.stock,
    bleedLeft: input.bleedLeft,
    bleedTop: input.bleedTop,
    bleedRight: input.bleedRight,
    bleedBottom: input.bleedBottom,
    printColour: input.printColour,
    printFormat: input.printFormat,
    printResolution: input.printResolution,
    additionalInformation: input.additionalInformation,
    trimSize: input.trimSize,
  };
}

const SizeTypeSpec_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"SizeType attributes\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sizeType","default":{"kind":"nothing"},"name":"sizeType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"pdfFileName","default":{"kind":"nothing"},"name":"pdfFileName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoMaxFileSize","default":{"kind":"nothing"},"name":"videoMaxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"staticMaxFileSize","default":{"kind":"nothing"},"name":"staticMaxFileSize","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoAspectRatio","default":{"kind":"nothing"},"name":"videoAspectRatio","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"staticAspectRatio","default":{"kind":"nothing"},"name":"staticAspectRatio","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoCodec","default":{"kind":"nothing"},"name":"videoCodec","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoFrameRate","default":{"kind":"nothing"},"name":"videoFrameRate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoBitRate","default":{"kind":"nothing"},"name":"videoBitRate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"staticResolution","default":{"kind":"nothing"},"name":"staticResolution","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"staticColour","default":{"kind":"nothing"},"name":"staticColour","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"format","default":{"kind":"nothing"},"name":"format","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoSupportAudioCodec","default":{"kind":"nothing"},"name":"videoSupportAudioCodec","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoSupportAudioBitRate","default":{"kind":"nothing"},"name":"videoSupportAudioBitRate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoSupportSampleRate","default":{"kind":"nothing"},"name":"videoSupportSampleRate","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"channels","default":{"kind":"nothing"},"name":"channels","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"videoAudioLevels","default":{"kind":"nothing"},"name":"videoAudioLevels","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"maxTruePeak","default":{"kind":"nothing"},"name":"maxTruePeak","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"stock","default":{"kind":"nothing"},"name":"stock","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bleedLeft","default":{"kind":"nothing"},"name":"bleedLeft","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bleedTop","default":{"kind":"nothing"},"name":"bleedTop","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bleedRight","default":{"kind":"nothing"},"name":"bleedRight","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"bleedBottom","default":{"kind":"nothing"},"name":"bleedBottom","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"printColour","default":{"kind":"nothing"},"name":"printColour","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"printFormat","default":{"kind":"nothing"},"name":"printFormat","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"printResolution","default":{"kind":"nothing"},"name":"printResolution","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"additionalInformation","default":{"kind":"nothing"},"name":"additionalInformation","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"trimSize","default":{"kind":"nothing"},"name":"trimSize","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"SizeTypeSpec","version":{"kind":"nothing"}}};

export const snSizeTypeSpec: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"SizeTypeSpec"};

export function texprSizeTypeSpec(): ADL.ATypeExpr<SizeTypeSpec> {
  return {value : {typeRef : {kind: "reference", value : snSizeTypeSpec}, parameters : []}};
}

export enum SizeType {
  MINI,
  BANNER,
  BOULEVARD,
  BUSINESS_LOUNGE,
  COLLECT_AND_CONNECT_TV,
  COMMUTE_SHEET_O1S,
  COMMUTE_SHEET_O2S,
  COMMUTE_EXPERIENTIAL,
  COMMUTE_METROLITE,
  COMMUTE_SEAT_BACK,
  COMMUTE_STATION_DOMINATION,
  COMMUTE_SUPERLITE,
  COMMUTE_SUPERLITE_SCROLLER,
  DIGITAL_LANDMARK,
  DIGITAL_PORTRAIT,
  ENTERPRISE,
  ENTICE,
  EVOKE_LANDSCAPE,
  EVOKE_PORTRAIT,
  EVOKE_TV,
  LANDMARK,
  LIGHTBOX,
  LONGREACH,
  METRO_EXECUTIVE,
  NON_STANDARD,
  PORTRAIT,
  RAIL_CONSEC,
  RAIL_LARGE_FORMAT,
  RAIL_PORTRAIT,
  RAIL_WOW_WALL,
  SHOPALITES,
  SMALL_FORMAT,
  SPECTACULAR,
  STREET_FURNITURE_PORTRAIT,
  SUPER_8,
  SUPERSITE,
  TOUCHDOWN,
}

const SizeType_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Different sizeTypes\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"24's / Mini Supers","default":{"kind":"nothing"},"name":"MINI","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Banner","default":{"kind":"nothing"},"name":"BANNER","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Boulevard","default":{"kind":"nothing"},"name":"BOULEVARD","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Business Lounge","default":{"kind":"nothing"},"name":"BUSINESS_LOUNGE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Collect & Connect TV","default":{"kind":"nothing"},"name":"COLLECT_AND_CONNECT_TV","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute 2 Sheet - O1S","default":{"kind":"nothing"},"name":"COMMUTE_SHEET_O1S","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute 2 Sheet - O2S","default":{"kind":"nothing"},"name":"COMMUTE_SHEET_O2S","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Experiential","default":{"kind":"nothing"},"name":"COMMUTE_EXPERIENTIAL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Metrolite","default":{"kind":"nothing"},"name":"COMMUTE_METROLITE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Seat Back","default":{"kind":"nothing"},"name":"COMMUTE_SEAT_BACK","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Station Domination","default":{"kind":"nothing"},"name":"COMMUTE_STATION_DOMINATION","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Superlite","default":{"kind":"nothing"},"name":"COMMUTE_SUPERLITE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Commute Superlite Scroller","default":{"kind":"nothing"},"name":"COMMUTE_SUPERLITE_SCROLLER","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Digital Landmark","default":{"kind":"nothing"},"name":"DIGITAL_LANDMARK","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Digital Portrait","default":{"kind":"nothing"},"name":"DIGITAL_PORTRAIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Enterprise","default":{"kind":"nothing"},"name":"ENTERPRISE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Entice (Digital Landscape)","default":{"kind":"nothing"},"name":"ENTICE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Evoke Landscape","default":{"kind":"nothing"},"name":"EVOKE_LANDSCAPE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Evoke Portrait","default":{"kind":"nothing"},"name":"EVOKE_PORTRAIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Evoke TV","default":{"kind":"nothing"},"name":"EVOKE_TV","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Landmark","default":{"kind":"nothing"},"name":"LANDMARK","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Lightbox","default":{"kind":"nothing"},"name":"LIGHTBOX","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Longreach","default":{"kind":"nothing"},"name":"LONGREACH","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Metro Executive","default":{"kind":"nothing"},"name":"METRO_EXECUTIVE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Non-Standard","default":{"kind":"nothing"},"name":"NON_STANDARD","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Portrait","default":{"kind":"nothing"},"name":"PORTRAIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Rail Consec","default":{"kind":"nothing"},"name":"RAIL_CONSEC","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Rail Large Format","default":{"kind":"nothing"},"name":"RAIL_LARGE_FORMAT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Rail Portrait","default":{"kind":"nothing"},"name":"RAIL_PORTRAIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Rail WOW Wall","default":{"kind":"nothing"},"name":"RAIL_WOW_WALL","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"ShopaLites","default":{"kind":"nothing"},"name":"SHOPALITES","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Small Format (4 x 2m etc)","default":{"kind":"nothing"},"name":"SMALL_FORMAT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Spectacular","default":{"kind":"nothing"},"name":"SPECTACULAR","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Street Furniture Portrait","default":{"kind":"nothing"},"name":"STREET_FURNITURE_PORTRAIT","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Super 8","default":{"kind":"nothing"},"name":"SUPER_8","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Supersite","default":{"kind":"nothing"},"name":"SUPERSITE","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"Touchdown","default":{"kind":"nothing"},"name":"TOUCHDOWN","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SizeType","version":{"kind":"nothing"}}};

export const snSizeType: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"SizeType"};

export function texprSizeType(): ADL.ATypeExpr<SizeType> {
  return {value : {typeRef : {kind: "reference", value : snSizeType}, parameters : []}};
}

/**
 * Unique placements that are overridden by specific tssPlacementId
 */
export interface PlacementOverride {
  frameName: string;
  sizeType: string;
  tssPlacementId: string;
}

export function makePlacementOverride(
  input: {
    frameName: string,
    sizeType: string,
    tssPlacementId: string,
  }
): PlacementOverride {
  return {
    frameName: input.frameName,
    sizeType: input.sizeType,
    tssPlacementId: input.tssPlacementId,
  };
}

const PlacementOverride_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.ooh","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Unique placements that are overridden by specific tssPlacementId\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"frameName","default":{"kind":"nothing"},"name":"frameName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"sizeType","default":{"kind":"nothing"},"name":"sizeType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"tssPlacementId","default":{"kind":"nothing"},"name":"tssPlacementId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PlacementOverride","version":{"kind":"nothing"}}};

export const snPlacementOverride: ADL.ScopedName = {moduleName:"kachemedia.specsheet.ooh", name:"PlacementOverride"};

export function texprPlacementOverride(): ADL.ATypeExpr<PlacementOverride> {
  return {value : {typeRef : {kind: "reference", value : snPlacementOverride}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.ooh.OohCampaignBooking" : OohCampaignBooking_AST,
  "kachemedia.specsheet.ooh.OohPlacement" : OohPlacement_AST,
  "kachemedia.specsheet.ooh.OohCampaign" : OohCampaign_AST,
  "kachemedia.specsheet.ooh.BookingDates" : BookingDates_AST,
  "kachemedia.specsheet.ooh.OohTablesMap" : OohTablesMap_AST,
  "kachemedia.specsheet.ooh.SizeTypeSpec" : SizeTypeSpec_AST,
  "kachemedia.specsheet.ooh.SizeType" : SizeType_AST,
  "kachemedia.specsheet.ooh.PlacementOverride" : PlacementOverride_AST
};
